import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type {
  CreateVehiclePayload,
  UpdateVehiclePayload,
  Vehicle,
  VehicleDeletePreview,
} from "#/types/vehicle";

export const vehicleApi = {
  create: (body: CreateVehiclePayload): Promise<ApiResponse<Vehicle>> =>
    api.post("/vehicle", body),
  getAll: (
    params?: BaseFilterParams
  ): Promise<ApiResponse<Paginated<Vehicle[]>>> =>
    api.get("/vehicle", { params }),
  getById: (id: number): Promise<ApiResponse<Vehicle>> =>
    api.get(`/vehicle/${id}`),
  update: (
    id: number,
    body: Partial<UpdateVehiclePayload>
  ): Promise<ApiResponse<Vehicle>> => api.patch(`/vehicle/${id}`, body),
  getDeletePreview: (id: number): Promise<ApiResponse<VehicleDeletePreview>> =>
    api.get(`/vehicle/${id}/delete-preview`),
  delete: (id: number): Promise<ApiResponse<void>> =>
    api.delete(`/vehicle/${id}`),
};
